var map = {
	"./en/common": 464,
	"./en/common.json": 464,
	"./en/course": 8906,
	"./en/course.json": 8906,
	"./en/home": 2482,
	"./en/home.json": 2482,
	"./en/tags": 8998,
	"./en/tags.json": 8998,
	"./id/common": 1610,
	"./id/common.json": 1610,
	"./id/course": 6750,
	"./id/course.json": 6750,
	"./id/home": 6903,
	"./id/home.json": 6903,
	"./id/tags": 2732,
	"./id/tags.json": 2732
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7655;
module.exports = webpackAsyncContext;